module.exports = __webpack_public_path__ + "static/img/ilustra_verso_rg.8ab9718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_verso_rg.png
// module id = XhLY
// module chunks = 2